/* Copyright (c) 2017 Backpack Health LLC */

import * as _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { getFontColorClassNameOLD } from '../styles/Colors';

function createText(Tag, className) {
  const Text = (props) => {
    const classes = classnames(
      className,
      props.className,
      getFontColorClassNameOLD(props.color),
      {
        'is-clickable': _.isFunction(props.onClick),
      }
    );

    const styles = _.assign({
      textOverflow: props.textOverflow || null,
      overflow: props.overflow || null,
      whiteSpace: props.whiteSpace || null,
      fontStyle: props.isItalic ? 'italic' : null,
      textTransform: props.textTransform ? props.textTransform : null,
      textAlign: props.textAlign ? props.textAlign : null,
    }, props.style);
    return (
      <Tag style={styles} className={classes} onClick={props.onClick}>
        {props.children}
      </Tag>
    );
  };

  Text.propTypes = {
    color: PropTypes.oneOf(['default', 'white', 'profile', 'error', 'warning', 'neutral', 'middle-gray', 'medDarkGray', 'dark-neutral', 'darkest-gray', 'light-neutral', 'inactive', 'light']),
    onClick: PropTypes.func,
    children: PropTypes.any,
    noBottomMargin: PropTypes.bool,
    isItalic: PropTypes.bool,
    textOverflow: PropTypes.oneOf(['ellipsis', 'clip', 'initial', 'inherit']),
    overflow: PropTypes.oneOf(['auto', 'hidden', 'visible', 'scroll']),
    whiteSpace: PropTypes.oneOf(['nowrap', 'normal']),
    textTransform: PropTypes.oneOf(['uppercase']),
    textAlign: PropTypes.oneOf(['justify', 'center']),
    className: PropTypes.string,
    style: PropTypes.object,
  };
  Text.defaultValues = {
    color: 'default',
  };

  return Text;
}


const ViewTitle = createText('div', 'cmp-text-view-title');
const Title2 = createText('div', 'cmp-text-title2');
const ViewHeadline = createText('div', 'cmp-text-view-headline');
const Body = createText('div', 'cmp-text-body');
const BodyText = createText('div', 'cmp-text-body');
const BodyMain = createText('div', 'cmp-text-body-main');
const Caption = createText('div', 'cmp-text-caption');
const Caption1 = createText('div', 'cmp-text-caption-1');
const Small = createText('div', 'cmp-text-small');
const Footnote = createText('div', 'cmp-text-footnote');
const TitleBold = createText('div', 'cmp-text-title-bold');
const Subheading = createText('div', 'cmp-text-subheading');
const Heading = createText('div', 'cmp-text-heading');
const ViewTitleBold = createText('div', 'cmp-text-view-title-bold');

export {
  ViewTitle,
  Title2,
  ViewHeadline,
  Heading,
  Subheading,
  TitleBold,
  Body,
  BodyText,
  BodyMain,
  Caption,
  Caption1,
  Small,
  Footnote,
  ViewTitleBold,
};
